/** The stored interval, not an older invite label, decides whether a meeting is all-day. */
export function meetingAllDayBoundary(
  start: Date | string,
  end: Date | string,
  timeZone = 'Europe/Rome',
): 'inclusive' | 'exclusive' | null {
  const first = new Date(start);
  const last = new Date(end);
  if (!Number.isFinite(first.getTime()) || !Number.isFinite(last.getTime()) || last <= first) return null;
  let formatter: Intl.DateTimeFormat;
  try {
    formatter = new Intl.DateTimeFormat('en-GB', {
      timeZone, year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit', hourCycle: 'h23',
    });
  } catch {
    return null;
  }
  const parts = (date: Date) => Object.fromEntries(
    formatter.formatToParts(date).map((part) => [part.type, part.value]),
  );
  const startParts = parts(first);
  const endParts = parts(last);
  if (startParts.hour !== '00' || startParts.minute !== '00') return null;
  if (endParts.hour === '23' && endParts.minute === '59') return 'inclusive';
  if (endParts.hour === '00' && endParts.minute === '00') return 'exclusive';
  return null;
}
